export default __webpack_public_path__ + "./fonts/kasmlogo.9af9432decce895fa24271ddf75e8e7c.svg";